import { getLoadDetails, getCarrierInfo } from '../../utils/api/load';
import {
  loadDetailsFetching,
  loadDetailsSucceeded,
  loadDetailsFailed,
  updateLoadDetails,
} from './slice';
import { setAlert } from '../alerts/slice';
import ALERT_TYPES from '../alerts/constants';
import { logger } from '../../utils/common';

export const fetchLoadDetails = (loadId, salesOrderBk, loadOverrides = {}) => async (dispatch, getState) => {
  try {
    const { modeType: { type } } = getState();
    dispatch(loadDetailsFetching());
    const { data: { model: details } } = await getLoadDetails(loadId, salesOrderBk, type);
    const updatedLoadDetails = {
      ...details,
      ...loadOverrides,
    };
    dispatch(loadDetailsSucceeded(updatedLoadDetails));

    try {
      const selectedLoadId = getState().loadDetails?.data?.loadId;
      if (!selectedLoadId) {
        return;
      }
      const { data: { model: secondaryInfo } } = await getCarrierInfo(details.carrierId);
      dispatch(updateLoadDetails(secondaryInfo));
    } catch (error) {
      logger.error(error);
    }
  } catch (error) {
    if (error.status !== 404) {
      dispatch(setAlert({
        type: ALERT_TYPES.error,
        message: 'Failed to fetch load details',
      }));
    }
    dispatch(loadDetailsFailed(error));
  }
};
